"use client";
import Image from "next/image";
import { Typography } from "./ui/typography";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { ProfilePopover } from "./common/proflie-popover";
import { Menu, X } from "lucide-react";
import { useAuthDialogStore } from "@/hooks/use-auth-dialog";
import useAuth from "@/hooks/use-auth";
import { useAuthStore } from "@/store/use-auth-store";

const MobileNavbar = () => {
  const pathname = usePathname();

  const { signIn } = useAuthDialogStore();
  const { getCurrentUserInfo, signOutUser } = useAuth();
  const [openMenu, setOpenMenu] = useState(false);
  const user = useAuthStore((state) => state.user);

useEffect(() => {
    (async () => {
      const response = await getCurrentUserInfo();
    })();
  }, []);

  const isAuth = !!user?.isAuthenticated;
  
  return (
    <>
      <div className="fixed top-0 border-b flex gap-3 z-50 bg-[#1E1D1D] w-full justify-between p-2 sm:hidden">
        <div className="flex gap-3 items-center">
          <div onClick={() => setOpenMenu((prev) => !prev)}>
            {!openMenu && <Menu className="w-full" />}
            {openMenu && <X className="w-full" />}
          </div>
          <Image
            src="/images/logo.webp"
            width={32}
            height={32}
            alt="Plusmongolia logo"
          />
        </div>
        {!isAuth && (
          <Button className="font-semibold rounded-sm" onClick={signIn.openDialog}>
            <Typography className="font-semibold text-white rounded-lg">
              Нэвтрэх
            </Typography>
          </Button>
        )}
        {isAuth && <ProfilePopover signOut={signOutUser} user={user} />}
      </div>
      {openMenu && (
        <div className="fixed top-[53px] flex items-center gap-3 flex-col bg-background w-full z-50 pt-4 h-full">
          {navItems.map((item, index) => {
            const isActive = pathname === item.href;
            return (
              <Link
                key={index}
                href={item.href}
                scroll={true}
                onClick={() => setOpenMenu(false)}
              >
                <Typography
                  className={`font-semibold text-white py-1 px-2 rounded-lg transition-colors ${
                    isActive ? "bg-[#FFFFFF0D]" : "hover:bg-[#FFFFFF0D]"
                  }`}
                >
                  {item.label}
                </Typography>
              </Link>
            );
          })}
        </div>
      )}
    </>
  );
};

export default MobileNavbar;

const navItems = [
  {
    label: "Нүүр",
    href: "/",
  },
  {
    label: "Арилжааны сигнал",
    href: "/trading-signal",
  },
  {
    label: "Цахим ном",
    href: "/ebook",
  },
  {
    label: "Видео хичээл",
    href: "/video-course",
  },
];
